// extracted by mini-css-extract-plugin
export default {"appBar":"AppBar_appBar__OsgIs","titulo":"AppBar_titulo__kCOfh"};